import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Entity, Guard, Result, UniqueEntityID } from '@digibricks/domains';
import MarkdownIt from 'markdown-it';
export var Answer = /*#__PURE__*/function (_Entity) {
  _inherits(Answer, _Entity);

  var _super = _createSuper(Answer);

  function Answer() {
    _classCallCheck(this, Answer);

    return _super.apply(this, arguments);
  }

  _createClass(Answer, [{
    key: "files",
    get: function get() {
      return this.props.files;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "clone",
    value: function clone() {
      return Answer.create(_objectSpread(_objectSpread({}, this.props), {}, {
        id: this.id.toString()
      })).getValue();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, this.props), {}, {
        description: this.props.description
      });
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
      return Result.ok();
    }
  }, {
    key: "updateFiles",
    value: function updateFiles(files) {
      this.props.files = files;
      return Result.ok();
    }
  }, {
    key: "addFile",
    value: function addFile(file) {
      if (!file) {
        return new BadInputError('File cannot be null when adding new file');
      }

      this.props.files.push(file);
      return Result.ok();
    }
  }, {
    key: "renderMarkdown",
    value: function renderMarkdown(content) {
      var md = new MarkdownIt();
      return Result.ok(md.render(content));
    }
  }], [{
    key: "validate",
    value: function validate(props) {
      var guardResult = Guard.againstNullOrUndefined(props, 'Answer Props');

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var guardCollections = [{
        argument: props.description,
        argumentName: 'Answer Description'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "create",
    value: function create(props) {
      var _props$files;

      var guardResult = Guard.againstNullOrUndefined(props, 'Answer Props');

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        files: (_props$files = props.files) !== null && _props$files !== void 0 ? _props$files : []
      });

      return Result.ok(new Answer(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var id = data.id,
            description = data.description,
            files = data.files;
        var answerProps = {
          id: id,
          description: description,
          files: files
        };
        return this.create(answerProps);
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return Answer;
}(Entity);